import Vue from 'vue'
import Router from 'vue-router'
import DefaultContainer from './containers/DefaultContainer';
// views only web
import Login from "./views/web/Login";
import Register from "./views/web/Register";
import Dashboard from "./views/web/Dashboard";
import Recover from "./views/web/RecuperarPass";
// views desk or web 
import Perfil from "./views/Perfil";
import Cursos from "./views/Cursos";
import Guias from "./views/Guias";
import GuiasList from "./views/GuiasList";
import Constructor from "./views/Constructor";
import RegistroUsuario from "./views/RegistroUsuario"
import Recursos from './views/Recursos'
import Actividades from './views/Actividades'
import PreviewMaterial from './views/PreviewMaterial'
import MostrarMaterial from './views/MostrarMaterial'
import RecycleBin from './views/RecycleBin'
import PreviewImprimir from './views/PreviewImprimir'
// views only desk
import RegistroClave from './views/RegistroClave.vue'
//services
import { TokenService } from "./services/storage.service";
import { LicenciaService } from './services/licencia.service';

import store from "./store/"


Vue.use(Router)
const pathRoot = (process.env.VUE_APP_IS_WEB === "true") ? '/login' : '/';

const routesWeb = [
  {
    path:'/',
    component: { render(c) {return c('router-view')  }},
    meta: {
      onlyWhenLoggedOut: true
    }
  },
  {
    path: "/cme",
    name: 'CME',
    component: DefaultContainer,
    disabled: true,
    children: [
      {
        path: 'inicio',
        name: 'Inicio',
        disabled: true,
        component: Dashboard
      },
      {
        path:'material',
        name: 'Material',
        disabled: true,
        component: {
          render(c) {return c('router-view')}
        },
        children: [
          {
            path: 'nuevo',
            name: 'Nuevo',
            disabled: true,
            component: Constructor
          },
          {
            path: 'preview/:id',
            name: 'Preview',
            disabled: true,
            component: PreviewMaterial,
            props: true,
          },
          {
            path: 'recursos/:type',
            name: 'Recursos',
            disabled: true,
            component: Recursos
          },
          {
            path: 'imprimir/:id',
            name: 'Imprimir',
            disabled: true,
            component: PreviewImprimir,
            props: true,
          },
          {
            path: 'editar/:id',
            name: 'Editar Material',
            disabled: true,
            component: Constructor
          },
        ]
      },
      /*{
        path: 'guias',
        name: 'Guías Educativas',
        disabled: true,
        component: Guias
      },*/
      {
        path:'guias',
        //name: 'Guías Educativas',
        disabled: true,
        component: {
          render(c) {return c('router-view')}
        },
        children: [
          {
            path: '',
            name: 'All',
            disabled: true,
            component: Guias
          },
          {
            path: ':id',
            name: 'GuiasList',
            disabled: true,
            component: GuiasList,
            props: true,
          },
        ]
      },
      {
        //Revisar bien la ruta por lo de webpack
        path: 'cursos/:materia',
        name: 'Mis Cursos',
        disabled: true,
        component: Cursos
      },
      {
        path: 'perfil/',
        name: 'Perfil',
        disabled: true,
        component: Perfil
      },
      {
        path: 'papelera/',
        name: 'Papelera',
        disabled: true,
        component:  RecycleBin
      }
    ]
  },
  {
    path: "/register",
    name: 'register',
    disabled: true,
    component: Register,
    meta: {
      public: true,  // Allow access to even if not logged in
      onlyWhenLoggedOut: true
    }
  },
  {
    path: "/login",
    name: 'login',
    disabled: true,
    component: Login,
    meta: {
      public: true,  // Allow access to even if not logged in
      onlyWhenLoggedOut: true
    }
  },
  {
    path: "/recoverpass",
    name: 'recoverpass',
    disabled: true,
    component: Recover,
    meta:{
      public:true,
      onlyWhenLoggedOut: true //permite recuperar de contraseña
    }
  }  
];
const routesDesk = [
  {
    path: '/',
    name: 'registro_clave',
    disabled: true,
    component: RegistroClave,
    meta: {
      public: true,  // Allow access to even if not logged in
      onlyWhenLoggedOut: true,
      onlyNewMacAddress: true
    }
  },
  {
    path: '/registro_usuario',
    name: 'registro_usuario',
    disabled: true,
    component: RegistroUsuario,
    meta: {
      public: true,  // Allow access to even if not logged in
      onlyWhenLoggedOut: true,
      onlyNewMacAddress: false
    }
  },
  {
    path: "/login",
    name: 'login',
    component: Login,
    meta: {
      public: true,  // Allow access to even if not logged in
      onlyWhenLoggedOut: true,
      onlyNewMacAddress: false
    }
  },
  {
    path: "/cme",
    name: 'home',
    //redirect: '/cme/dashboard',
    component: DefaultContainer,
    disabled: true,
    meta: {
      onlyNewMacAddress: false
    },
    children: [
      {
        path: 'inicio',
        name: 'Inicio',
        disabled: true,
        component: Dashboard
      },
      {
        path: 'perfil',
        name: 'Perfil',
        disabled: true,
        component: Perfil
      },
      {
        path: 'guias',
        name: 'Guías Educativas',
        disabled: true,
        component: Guias
      },
      {
        //revisar bien por las rutas de webpack
        path: 'cursos/:materia',
        name: 'Mis Cursos',
        disabled: true,
        children: [
          /*{
            path: 'ingles',
            name: 'Ingles',
            component: Ingles,
          }, {
            path: 'ingles/actividad/:id',
            name: 'Actividad',
            component: Actividad,
          }*/
        ]
      }
    ]
  },
];


const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: JSON.parse(process.env.VUE_APP_IS_WEB) ? routesWeb : routesDesk,
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();
  const needMatchAddress = to.matched.some(record => record.meta.onlyNewMacAddress);

  if (!isPublic && !loggedIn) {
    return next({
      path: pathRoot,
      query: { redirect: to.fullPath }  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next({
      path: '/cme/inicio',
      query: { redirect: to.fullPath }
    })
  }

  if (needMatchAddress) {
    //console.log(TokenService.getToken());
    LicenciaService.getSearchMatchMacAddress().then(resp => {
      Promise.resolve(
        { data: resp }
      ).then(
        result => {
          console.log(result);
          if (result.data) {

            /* verificar si la clave de licencia está vinculada a un usuario ya registrado para mostrar o no el registro de usuario */
            let user = result.data.success.user;
            if (user == null) {
              return next({
                path: '/registro_usuario',
                query: { redirect: to.fullPath }
              });
            } else {

              // ya hay un registro vinculado a la licencia por lo que se le pide iniciar sesión
              return next({
                path: '/login',
                query: { redirect: to.fullPath }
              });
            }

          }

        });
    });
  }

  // Remove aside if is active
  let body = document.getElementsByTagName('body');
  body[0].classList.remove("aside-menu-show");
  body[0].classList.remove("aside-menu-lg-show");
  //

  // If new constructors comes from other rather preview clear cache :::: HC
  if(to.fullPath == '/cme/material/nuevo' && from.fullPath != '/cme/material/preview/dev') {
    store.dispatch("constructor/clear");
  }
  ///////
  next();
});

export default router
